"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkLat = checkLat;
exports.checkLng = checkLng;
exports.isArray = isArray;
exports.isCl = isCl;
exports.isExternal = isExternal;
exports.isFloat = isFloat;
exports.isImage = isImage;
exports.isInt = isInt;
exports.isJSON = isJSON;
exports.isMobile = isMobile;
exports.isNumber = isNumber;
exports.isPrice = isPrice;
exports.isSn = isSn;
exports.isString = isString;
exports.isSvg = isSvg;
exports.patt = patt;
exports.validAlphabets = validAlphabets;
exports.validEmail = validEmail;
exports.validLowerCase = validLowerCase;
exports.validPassword = validPassword;
exports.validPhone = validPhone;
exports.validPlate = validPlate;
exports.validRule1 = validRule1;
exports.validRule1Special = validRule1Special;
exports.validRule1Special800 = validRule1Special800;
exports.validRule2 = validRule2;
exports.validRule2Special = validRule2Special;
exports.validRule3 = validRule3;
exports.validRule3Special = validRule3Special;
exports.validRule3Special20 = validRule3Special20;
exports.validURL = validURL;
exports.validUpperCase = validUpperCase;
exports.validUsername = validUsername;
require("core-js/modules/es6.number.constructor");
var _typeof2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.regexp.to-string");
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
function validUsername(str) {
  var valid_map = ['admin', 'editor', 'adminchengge'];
  return valid_map.indexOf(str.trim()) >= 0;
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
function validURL(url) {
  var reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
function validLowerCase(str) {
  var reg = /^[a-z]+$/;
  return reg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
function validUpperCase(str) {
  var reg = /^[A-Z]+$/;
  return reg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
function validAlphabets(str) {
  var reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
function validEmail(email) {
  var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return !reg.test(email);
}

/**
 * @param {string} phone
 * @returns {Boolean}
 */
function validPhone(phone) {
  var reg = /^1\d{10}$/;
  return !reg.test(phone);
}

/**
 * @param {string} carPlate
 * @returns {Boolean}
 */
function validPlate(plate) {
  var reg = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/;
  return !reg.test(plate);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true;
  }
  return false;
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]';
  }
  return Array.isArray(arg);
}

/**
 * @param {string} password
 * @returns {Boolean}
 */
function validPassword(str) {
  return str.trim().length > 6;
}

/**
 * @param {string} str 只能输入中英文数字空格(-_./~)（）
 * @returns {Boolean}
 */
function validRule1(str) {
  // return str.length < 1
  var reg = /^[a-zA-Z0-9\u4e00-\u9fa5()（）{} -_./~]{1,}$/;
  return !reg.test(str);
}

/**
 * @param {string} str 只能输入英文数字-_./
 * @returns {Boolean}
 */
function validRule2(str) {
  // return str.length < 1
  var reg = /^[a-zA-Z0-9\-_.;；/]{1,}$/;
  return !reg.test(str);
}

/**
 * @param {string} str 只能输入英文数字_
 * @returns {Boolean}
 */
function validRule3(str) {
  // return str.length < 1
  var reg = /^[a-zA-Z0-9\_]{1,}$/;
  return !reg.test(str);
}

/**
 * @param {string} str 只能输入中英文数字空格(-_./~)限制最大长度50
 * @returns {Boolean}
 */
function validRule1Special(str) {
  // return str.length < 1
  var reg = /^[a-zA-Z0-9\u4e00-\u9fa5(){} -_./~]{1,50}$/;
  return !reg.test(str);
}

/**
 * @param {string} str 只能输入中英文数字空格(-_./~)限制最大长度800
 * @returns {Boolean}
 */
function validRule1Special800(str) {
  // return str.length < 1
  var reg = /^[a-zA-Z0-9\u4e00-\u9fa5(){} -_./~]{1,800}$/;
  return !reg.test(str);
}

/**
 * @param {string} str 只能输入英文数字-_./限制最大长度50
 * @returns {Boolean}
 */
function validRule2Special(str) {
  // return str.length < 1
  var reg = /^[a-zA-Z0-9\-_./]{1,50}$/;
  return !reg.test(str);
}

/**
 * @param {string} str 只能输入英文数字_限制最大长度50
 * @returns {Boolean}
 */
function validRule3Special(str) {
  // return str.length < 1
  var reg = /^[a-zA-Z0-9\_]{1,50}$/;
  return !reg.test(str);
}

/**
 * @param {string} str 只能输入英文数字_限制最大长度20
 * @returns {Boolean}
 */
function validRule3Special20(str) {
  // return str.length < 1
  var reg = /^[a-zA-Z0-9\_]{1,20}$/;
  return !reg.test(str);
}

// 经度
function checkLng(val) {
  var longrg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/;
  return !longrg.test(val);
}

// 纬度
function checkLat(val) {
  var latreg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/;
  return !latreg.test(val);
}

/**
 * Check JSON String
 * @param {String} str
 */
function isJSON(str) {
  if (typeof str === 'string') {
    try {
      var obj = JSON.parse(str);
      if (obj && (0, _typeof2.default)(obj) === 'object') {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }
}

// 数字
function isNumber(value) {
  value = Number(value);
  return typeof value === 'number' && !isNaN(value);
}

// 0和正整数
function isInt(num) {
  var reg = /^([1-9]\d*|[0]{1,1})$/;
  return !reg.test(num);
}

// 正整数
function isSn(num) {
  var reg = /^([1-9]\d*)$/;
  return !reg.test(num);
}
// 百分数
function patt(num) {
  var reg = /^\d+\.?\d{0,2}$/;
  return !reg.test(num);
}

// 大于等于0的整数及最多两位小数
function isPrice(num) {
  var reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/;
  return !reg.test(num);
}

// 整数、浮点数都可以通过
function isFloat(num) {
  var reg = /^\d+(\.\d+)?$/;
  return !reg.test(num);
}
function isSvg(path) {
  var reg = /\.(svg)$/;
  return reg.test(path);
}
function isImage(path) {
  var reg = /\.(png|jpg|gif|jpeg|webp|PNG|JPG|JPEG|GIF|WEBP)$/;
  return reg.test(path);
}
function isCl(num) {
  var reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?cl$/;
  return !reg.test(num);
}

// 是否为移动端
function isMobile() {
  var userAgent = navigator.userAgent.toLowerCase();
  // 用 test 匹配浏览器信息
  if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(userAgent)) {
    return true;
  } else {
    return false;
  }
}